import React from 'react';

import Button from '@/components/common/Button/Button';

type SwapProps = {
  onClick?: () => void;
  customWidth?: string;
};

export const Swap: React.FC<SwapProps> = ({ onClick }) => {
  return (
    <Button theme={'red'} onClick={onClick} className="h-9">
      <span className="px-3">Swap</span>
    </Button>
  );
};
